import { lazy } from 'solid-js'
import { messages } from '../../pages/account-page/account-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/account-page/account-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/account',
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
